import React from "react";

export default function WriteYourOwnBlog() {
  return (
    <section className="max-w-6xl mx-auto px-6 pb-10">
      <h2 className="text-xl font-extrabold text-slate-900 mb-5">
        Write Your Own Blog
      </h2>

      <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6 sm:p-8 flex  items-center gap-8">
        <div className="order-2 sm:order-1 w-full sm:w-64 h-48 rounded-xl overflow-hidden bg-slate-200 shrink-0">
          <img
            src="/img/blog/write-blog-illustration.svg"
            alt="Share your travel story"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="order-1 sm:order-2 text-center ">
          <h3 className="text-[40px] font-extrabold text-slate-900 mb-2">
            Start Sharing your{" "}
            <span className="text-[#7209B7]">Travel Stories</span>
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed mb-5 ">
            Login or create an account to write blogs, share tips and
            inspire travelers.
          </p>
          <a
            href="/write-blog"
            className="inline-block bg-[#7209B7] text-white font-semibold text-sm px-7 py-3 rounded-full hover:bg-[#5a07a0] active:scale-95 transition-all duration-200"
          >
            Login/Sign Up
          </a>
        </div>
      </div>
    </section>
  );
}
